/* eslint-disable no-empty-pattern */
import Vue from 'vue';
/* eslint no-param-reassign: 0 */
import { BroadcastService } from '../services/broadcast.service';

const broadcastState = {
  state: '',
  broadcast: null,
  broadcastInterval: null,
  streamingDevice: null,
  newControlCenter: false,
};

const mutations = {
  /**
   * Set broadcast and broadcaststate
   * @param {Object} state
   * @param {Object} param1
   * @param {String} param1.id
   * @param {Boolean} param1.loading
   * @param {Boolean} param1.error
   * @param {Object} param1.data
   */
  set(state, { id, data }) {
    if (state.broadcast && state.broadcast.id === id) {
      const broadcastData = {};

      // eslint-disable-next-line
      for (const [key, value] of Object.entries(data)) {
        if (key === 'life_cycle_status') {
          broadcastData.status = {
            life_cycle_status: value,
          };
        } else {
          broadcastData[key] = value;
        }
      }

      Vue.set(state, 'broadcast', { ...state.broadcast, ...broadcastData });
    }
  },
  setBroadcast(state, broadcast) {
    state.broadcast = broadcast ? Object.assign(state.broadcast || {}, broadcast) : null;
    if (broadcast && typeof broadcast.assigned_to === 'undefined' && typeof state.broadcast !== 'undefined') {
      delete state.broadcast.assigned_to;
    }
    state.state = '';
  },
  setState(state, type) {
    state.state = type;
  },
  setStreamingDevice(state, device) {
    state.streamingDevice = device;
  },
  setNewControlCenter(state) {
    state.newControlCenter = true;
  },
};

const getters = {
  current: state => state.broadcast,
  state: state => state.state,
  streamingDevice: state => state.streamingDevice,
  newControlCenter: state => state.newControlCenter,
};

const actions = {
  schedule: async ({}, data) => {
    try {
      const broadcast = await BroadcastService.schedule(data);
      return { id: broadcast };
    } catch (e) {
      return e.error || e;
    }
  },
  getBroadcast: async ({ commit, state, dispatch }, { id, interval = false }) => {
    try {
      commit('setState', 'loading');
      const broadcast = await BroadcastService.getBroadcast(id);
      commit('setBroadcast', broadcast);

      if (state.broadcastInterval && ['reclaimed', 'revoked', 'abandoned', 'completed'].includes(broadcast.status.life_cycle_status)) {
        if (broadcast.stream.status !== 'active') {
          clearInterval(state.broadcastInterval);
          state.broadcastInterval = null;
        }
      }

      if (interval) {
        if (!state.broadcastInterval && ['created', 'ready', 'testStarting', 'testing', 'testStopping', 'liveStarting', 'live', 'liveStopping', 'complete'].includes(broadcast.status.life_cycle_status)) {
          state.broadcastInterval = setInterval(() => {
            dispatch('getBroadcast', { id });
          }, 5000);
        }
      }
      return broadcast;
    } catch (e) {
      commit('setState', 'error');
      return false;
    }
  },
  getQuestions: async ({}, id) => {
    try {
      const qa = await BroadcastService.getQuestions(id);
      return qa;
    } catch (e) {
      return false;
    }
  },
  toggleQ: async ({}, { id, qid }) => {
    try {
      await BroadcastService.answerQ(id, qid, '');
      return true;
    } catch (e) {
      return false;
    }
  },
  deleteQ: async ({}, { id, qid }) => {
    try {
      await BroadcastService.deleteQ(id, qid);
      return true;
    } catch (e) {
      return false;
    }
  },
  answerQ: async ({}, { id, qid, answer }) => {
    try {
      await BroadcastService.answerQ(id, qid, answer);
      return true;
    } catch (e) {
      return false;
    }
  },
  update: async ({ commit }, { id, data }) => {
    try {
      const broadcast = await BroadcastService.updateBroadcast(id, data);
      commit('setBroadcast', broadcast);
      return true;
    } catch (e) {
      return e.error || e;
    }
  },
  views: async ({}, id) => {
    try {
      const views = await BroadcastService.getViews(id);
      return views;
    } catch (e) {
      return false;
    }
  },
  unsetBroadcast: ({ commit, state }) => {
    commit('setBroadcast', null);
    clearInterval(state.broadcastInterval);
    state.broadcastInterval = null;
  },
  uploadPoster: async ({}, { id, file }) => {
    try {
      const poster = await BroadcastService.uploadPoster(id, file);
      return poster;
    } catch (e) {
      return false;
    }
  },
  stop: async ({ commit }, id) => {
    try {
      const broadcast = await BroadcastService.stopBroadcast(id);
      commit('setBroadcast', broadcast);
      return true;
    } catch (e) {
      return e.error || e;
    }
  },
  updateScorebar: async ({}, { id, sport }) => {
    try {
      await BroadcastService.updateScorebar(id, sport);
      return true;
    } catch (e) {
      return false;
    }
  },
  delete: async ({}, id) => {
    try {
      await BroadcastService.deleteBroadcast(id);
      return true;
    } catch (e) {
      return false;
    }
  },
  // eslint-disable-next-line
  handleMessage: ({ commit }, { id, message }) => {
    commit('set', { id, data: message.payload });
  },
};

export default {
  namespaced: true,
  state: broadcastState,
  mutations,
  getters,
  actions,
};
